interface IsBlockedDomainParams {
  email?: string;
  blockedDomains: string[];
}

const isBlockedDomain = ({
  email,
  blockedDomains
}: IsBlockedDomainParams): boolean => {
  const domain = email?.split("@")[1];
  return domain ? blockedDomains.includes(domain) : false;
};

export default isBlockedDomain;
